import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import downarr from "./assets/down-arrow.png";
import prof from "./profilepic.jpg";
import "./App.css";
import "./cursor.css";
import projectimglist from "./eipcaimg.json"
import graderlist from "./beargraderimg.json"
import activities from "./activities.json"
import CursorFollow from "./cursorfollow";
import Slider from "react-slick";

function App() {
  const [activeSection, setActiveSection] = useState("Introduction");
  const [theme, setTheme] = useState("light");
  const [expandedProject, setExpandedProject] = useState(null);
  const [fullImage, setFullImage] = useState(null); 
  
  
  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const handleImageClick = (src) => {
    setFullImage(src); 
  };

  const closeModal = () => {
    setFullImage(null); 
  };

  const handleExpand = (project) => {
    setExpandedProject((prev) => (prev === project ? null : project));
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      { threshold: 0.3 }
    );  

    const sections = document.querySelectorAll("section");
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  const handleSetActive = (section) => {
    setActiveSection(section);
  };

  useEffect(() => {
    consoleText(
      ['print("Welcome!")', 'console.log("Welcome!");', 'std::cout << "Welcome!";'],
      "text",
      ["tomato", "rebeccapurple", "lightblue"]
    );

    function consoleText(words, id, colors) {
      if (colors === undefined) colors = ["#fff"];
      let visible = true;
      const con = document.getElementById("console");
      let letterCount = 1;
      let x = 1;
      let waiting = false;
      const target = document.getElementById(id);
      target.setAttribute("style", "color:" + colors[0]);

      window.setInterval(function () {
        if (letterCount === 0 && waiting === false) {
          waiting = true;
          target.innerHTML = words[0].substring(0, letterCount);
          window.setTimeout(function () {
            const usedColor = colors.shift();
            colors.push(usedColor);
            const usedWord = words.shift();
            words.push(usedWord);
            x = 1;
            target.setAttribute("style", "color:" + colors[0]);
            letterCount += x;
            waiting = false;
          }, 1000);
        } else if (letterCount === words[0].length + 1 && waiting === false) {
          waiting = true;
          window.setTimeout(function () {
            x = -1;
            letterCount += x;
            waiting = false;
          }, 1000);
        } else if (waiting === false) {
          target.innerHTML = words[0].substring(0, letterCount);
          letterCount += x;
        }
      }, 120);
      //wowowowow

      window.setInterval(function () {
        if (visible === true) {
          con.className = "console-underscore hidden";
          visible = false;
        } else {
          con.className = "console-underscore";
          visible = true;
        }
      }, 400);
    }
  }, []);

  const achievementsData = [
    {
      title: "ISEF2024 - Grand Awards",
      description: "EIPCA has honored to be Thailand Representatives to compete in the World's Largest Science Fair known as International Science and Engineering Fair 2024 at Los Angelees, California in United States. We won the 3rd place grand award in Translational Medical Science.",
      images:
            [
              "ISEF/ISEF (1).jpg", 
              "ISEF/ISEF (2).jpg", 
              "ISEF/ISEF (3).jpg", 
              "ISEF/ISEF (4).jpg",
              "ISEF/ISEF (5).jpg",
              "ISEF/ISEF (6).jpg",
              "ISEF/ISEF (7).jpg", 
              "ISEF/ISEF (8).jpg", 
              "ISEF/ISEF (9).jpg"
            ]
    },
    {
      title: "Intel AI Impact Creators - Regional Winner",
      description: "EIPCA has comepete in Intel AI Global Impact Festival 2023 and won the Regional Awards total of 3000 USD",
      images: 
            [
              "Intel/wow (1).png", 
              "Intel/wow (2).png", 
              "Intel/wow (3).png", 
              "Intel/wow (4).png",
              "Intel/wow (5).png",
              "Intel/wow (6).png"
            ]
    },
    {
      title: "TIA2023 - 1st Place Winner & Best English Pitching Award",
      description: "Moreover EIPCA has won the best innovation of the year in Thailand Innovation Awards 2023 and Recieve Royal Cup and chance to compete internationally at Taiwan International Science Fair 2024",
      images:
            [
              "TIA/whoa (2).png", 
              "TIA/whoa (3).png", 
              "TIA/whoa (4).png",
              "TIA/whoa (5).png",
              "TIA/whoa (6).png"
            ]
    },
    {
      title: "TISF2024 - 1st Runner Up",
      description: "We continue to enhance EIPCA and participate in Taiwan International Science Fair 2024, and we manage to won the First Runner Up award in Health and Medical Science Category",
      images: 
            [
              "TISF/TISF (1).jpg", 
              "TISF/TISF (2).jpg", 
              "TISF/TISF (3).jpg",
              "TISF/TISF (4).jpg",
              "TISF/TISF (5).jpg",
              "TISF/TISF (6).jpg"
            ],
    },
  ];

  return (
    <div className={`app-container ${theme}`}  >
      <nav className="navbar">
        {["Introduction", "Profile", "My Projects", "Achievements"].map((item) => (
          <Link
            key={item}
            to={item}
            smooth={true}
            duration={800}
            spy={true}
            onSetActive={handleSetActive}
            className={activeSection === item ? "active" : ""}
          >
            {item}
          </Link>
        ))}
       <div className="theme-switch">
       <div className={`switch ${theme === "dark" ? "dark-theme" : "light-theme"}`} onClick={toggleTheme}>
          <div className="switch-ball">
            {theme === "dark" ? (
              <img
                src="https://images.rawpixel.com/image_png_800/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvdjk5My03MS5wbmc.png"
                alt="Moon (Dark Theme)"
                className="theme-icon"
              />
            ) : (
              <img
                src="https://cdn-icons-png.flaticon.com/512/467/467619.png"
                alt="Sun (Light Theme)"
                className="theme-icon"
              />
            )}
          </div>
        </div>
      </div>

      </nav>


      <CursorFollow />
      <section id="Introduction" className="intro-section">
        <div className="console-container">
          <span id="text"></span>
          <div className="console-underscore" id="console">
            &#95;
          </div>
          <p>Please take your time, and scroll to discover about me!</p>
          <div className="down-arrow">
            <img className="arrow" src={downarr} alt="arr"/>
          </div>
        </div>
      </section>


      <section id="Profile" className="profile-section" >
        <div className="profile-container">
          <div className="profile-image">
            <img src={prof} alt="Profile" />
          </div>
          <div className="profile-description">
            <h2>Hello! I'm Khunasin,</h2>
            <p>I'm a passionate developer who aims to be a little force to  make this world a better place.<br></br>
            I Specialized in Full-stack web development, databases and Artificial Neural Network. <br></br>I'm also a good learner and always loved to learn new things</p>
            <img align="left" alt="HTML" width="50px" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-plain.svg" />
            <img align="left" alt="CSS" width="50px" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg" />
            <img align="left" alt="Python" width="50px" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-plain.svg" />
            <img align="left" alt="C++" width="50px" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-line.svg" />
            <img align="left" alt="JS" width="50px" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-plain.svg" />
            <img align="left" alt="React" width="50px" src="logo512.png" />
            <img align="left" alt="React" width="50px" src="https://raw.githubusercontent.com/devicons/devicon/6910f0503efdd315c8f9b858234310c06e04d9c0/icons/tensorflow/tensorflow-original.svg" />
          </div>
        </div>
      </section>

      <section id="My Projects" className="projects-section">
      <h1>My Projects</h1>
      <p>Here are some of my main projects</p>

      {/* Main Project 1 */}
      <div className="project-card">
        <h2>EIPCA - Smart Portable ECG</h2>
        <p>EIPCA Orginally stands for "Electrocardiogram Interpretation patterns for Cardiovascular Abnormalities Prediction" is my 3-year-long group project research with goals to help save lives of millions of people around the world by reducing cost of ECG technologies to reach everone's hand affordbly while maintaining effectiveness as ECG used in hospital. <a href="https://partner.projectboard.world/isef/project/tmed041t-eipca-portable-12-lead-ecg-rapid-cvd-screening" target="_blank" rel="noopener noreferrer">Full Details here (projectboard)</a>
        </p>
        

        {/* Video Demo */}
        <div className="video-container">
          <video width="100%" height="auto" controls>
            <source src={process.env.PUBLIC_URL + "/EipcaDemo.mp4"} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Expand Button */}
        <button onClick={() => handleExpand("project1")}>
          {expandedProject === "project1" ? "Collapse" : "Learn More"}
        </button>

        {/* Carousel */}
        <div
          className={`carousel-container ${
            expandedProject === "project1" ? "expanded" : ""
          }`}
        >
            <p>Additional technical Details :</p>
            <p> EIPCA has 3 main operation - IOT Hardware,Web-application and Artificial Intelligence  <br></br> - IOT hardware were developed using Arduino and ESP32 while software uses ReactJS, Python (backend and AI) and firebase as database <br></br>
            - AI were developed to process graph and were developed using Bi-LSTM model signal processing (Old model was CNN with VGG-19 pre-trained model) </p>
            <p> My part in Development was full-stack web development, mainly in Backend Operation including Databases and AI model <br></br>
               <a href="https://eipca.vercel.app/" target="_blank" rel="noopener noreferrer">Visit EIPCA's Web-application</a> <br></br>
               User : test@test.com <br></br>
               Pass : 123456</p>
            
          <div className="carousel">
            {projectimglist.map((src, index) => (
              <img
                key={index}
                src={process.env.PUBLIC_URL + "/" + src}
                alt={`Project ${index + 1}`}
                onClick={() => handleImageClick(src)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Main Project 2 */}
      <div className="project-card">
        <h2>Bear's Personal Grader</h2>
        <p>
          Entirely developed by me and establishing this as a side project and hobby to do in free time while learning in CEDT, I have created the privately use competitive programming grader website. This not only help me practices in fully functional web-developing skills, it also help me practices in-class programming knowledge effectively. 
        </p>
        <button onClick={() => handleExpand("project2")}>
          {expandedProject === "project2" ? "Collapse" : "Learn More"}
        </button>
        <div
          className={`carousel-container ${
            expandedProject === "project2" ? "expanded" : ""
          }`}
        >
          <p>
            Grader is developed using Node.JS in ReactJS in both frontend and backend <br></br> 
            <a href="https://bear-grader.vercel.app/" target="_blank" rel="noopener noreferrer">Visit Grader here</a>
            <br></br>
                User : test@test.com <br></br>
                Pass : 123456
          </p>
          <div className="carousel">
            {graderlist.map((src, index) => (
              <img key={index} src={process.env.PUBLIC_URL + "/" + src} alt={`Project ${index + 1}`}
              onClick={() => handleImageClick(src)} />
            ))}
          </div>
        </div>
      </div>
    </section>

    <section id="Achievements" className="achievements-section">
      <h1>Achievements</h1>
      <div className="achievements-container">
        {achievementsData.map((award, index) => (
          <div key={index} className="achievement-card">
            <div className="achievement-carousel">
            <div className="achievement-info">
              <h2>{award.title}</h2>
              <p>{award.description}</p>
            </div>
            <Slider
              {...{
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
              }}>
              {award.images.map((image, imgIndex) => (
                <div key={imgIndex} className="carousel-slide">
                  <img
                    src={process.env.PUBLIC_URL + "/" + image}
                    alt={`Awards ${imgIndex + 1}`}
                  />
                </div>
              ))}
            </Slider>
            </div>
          </div>
        ))}
      </div>
      <div className="gallery-container">
        <h3>Never stop learning!</h3>
        <p>Above are some awards that is for me, proudest to present. There are plenty more awards I have not mentioned but my key point is to know that, learning is important aspect of life, and experience is key for greater good! <br></br>
        I also seek other activities for example Robotics and AI of First tech challenge, Thailand ICT awards, and visiting tech corporation to learn and experience working environment!</p>
        <div className="carousel2">
          {activities.map((src, index) => (
            <img
              key={index}
              src={process.env.PUBLIC_URL + "/" + src}
              alt={`Project ${index + 1}`}
              onClick={() => handleImageClick(src)} 
            />
          ))}
        </div>
      </div>
    </section>
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>About Website</h3>
          <p>
            This website is developed as a part of cirriculum vitae, resume and portfolio for Khunasin Suksri. Any feedbacks and comments are appreciated :)
          </p>
        </div>
        <div className="footer-column">
          <h3>Contact</h3>
          <ul>
            <li>Email: khunasinsooksri@gmail.com</li>
            <li>Phone: (+66) 932789556</li>
            <li>Location: Bangkok, Thailand</li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Follow Me</h3>
          <ul className="social-links">
          <li>
            <a href="https://github.com/bearior" target="_blank" rel="noreferrer">
            <img src="https://raw.githubusercontent.com/devicons/devicon/6910f0503efdd315c8f9b858234310c06e04d9c0/icons/github/github-original.svg" alt="Github" />
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/khunasin-suksri-bb8796293/" target="_blank" rel="noreferrer">
              <img src="https://raw.githubusercontent.com/devicons/devicon/6910f0503efdd315c8f9b858234310c06e04d9c0/icons/linkedin/linkedin-original.svg" alt="LinkedIn" />
            </a>
          </li>
          <li>
            <a href="https://instagram.com/bear.ior" target="_blank" rel="noreferrer">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/900px-Instagram_icon.png" alt="Instagram" />
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/khunasin.sooksri/" target="_blank" rel="noreferrer">
              <img src="https://raw.githubusercontent.com/devicons/devicon/6910f0503efdd315c8f9b858234310c06e04d9c0/icons/facebook/facebook-plain.svg" walt="Facebook" />
            </a>
          </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>©2024 Khunasin Suksri. All Rights Reserved.</p>
      </div>
    </footer>

      {fullImage && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <img src={fullImage} alt="Full-size" />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
